import http from 'utils/http';
import { getAgentLanguagesUrl } from './apiUrls';
import { AgentLanguagesResponse } from './types';

export async function getAgentLanguages(workspaceId?: string, agentId?: string): Promise<AgentLanguagesResponse> {
  const { data } = await http.get(getAgentLanguagesUrl(workspaceId, agentId));
  return {
    multi_language: data?.multi_language ?? false,
    languages: (data.languages ?? []).map((language: { code: string; name: string }) => ({
      label: language.name,
      value: language.code
    }))
  };
}
